export * from './locale-aware-base.component'
export * from './locale.service'
export * from './seo-aware-base.component'
